/* global firebase */
export const getRequestToken = firebase
  .functions()
  .httpsCallable("getRequestToken");
export const login = firebase.functions().httpsCallable("login");
export const stats = firebase.functions().httpsCallable("stats");
export const refresh = firebase.functions().httpsCallable("refresh");
